import { createFileRoute, redirect } from '@tanstack/react-router'

import type { EmailSection } from '@/components/settings/email-sidebar'
import type { FormsSection } from '@/components/settings/forms-sidebar'
import type { IntegrationsSection } from '@/components/settings/integrations-sidebar'
import type { ServicesSection } from '@/components/settings/services-sidebar'

type CommunicationsSearch = {
  section?: string
}

const emailSectionMap: Record<string, EmailSection> = {
  'connect-gmail': 'senders',
  // Custom mail domains were removed; their old links land on Senders.
  'email-domain': 'senders',
  'email-inbox': 'senders',
  templates: 'saved-templates',
  'system-templates': 'automated-emails',
}

const servicesSectionMap: Record<string, ServicesSection> = {
  'quote-templates': 'quote-templates',
}

const formsSectionMap: Record<string, FormsSection> = {
  'forms-embed': 'publish',
  'forms-options': 'fields-services',
  'forms-customization': 'confirmation',
  'forms-analytics': 'analytics',
  'forms-unavailable-dates': 'availability',
}

const integrationsSectionMap: Record<string, IntegrationsSection> = {
  calendar: 'calendar',
}

export const Route = createFileRoute('/_app/_settings/communications')({
  validateSearch: (search: Record<string, unknown>): CommunicationsSearch => {
    return {
      section: search.section as string | undefined,
    }
  },
  beforeLoad: ({ search }) => {
    const section = search.section || 'connect-gmail'

    if (emailSectionMap[section]) {
      throw redirect({ to: '/email', search: { section: emailSectionMap[section] } })
    }
    if (servicesSectionMap[section]) {
      throw redirect({ to: '/services', search: { section: servicesSectionMap[section] } })
    }
    if (formsSectionMap[section]) {
      throw redirect({ to: '/forms', search: { section: formsSectionMap[section] } })
    }
    if (integrationsSectionMap[section]) {
      throw redirect({
        to: '/integrations',
        search: { section: integrationsSectionMap[section] },
      })
    }
    if (section === 'notifications') {
      throw redirect({ to: '/notifications' })
    }

    throw redirect({ to: '/email', search: { section: 'senders' as EmailSection } })
  },
})
